import { AbstractControl, ValidatorFn } from '@angular/forms';

const ONEDRIVE_DOMAIN = 'onedrive.live.com/';
const ONEDRIVE_ID_PATTERN = /^(?:d\/)?([a-zA-Z0-9-_]{2,})(?:[#/=?].*)?$/i;

export const validateOneDriveDomain = (url: string): boolean => url.startsWith(ONEDRIVE_DOMAIN);

export const validateOneDriveId = (url: string): boolean => {
  const pathAfterDomain = url.slice(ONEDRIVE_DOMAIN.length);
  return ONEDRIVE_ID_PATTERN.test(pathAfterDomain);
};

export const validUrlValidator: ValidatorFn = ({ value }: AbstractControl<string>) => {
  const scheme = 'https://';
  if (value.startsWith(scheme)) {
    value = value.slice(scheme.length);
  }
  if (!validateOneDriveDomain(value)) {
    return { invalidUrl: { reason: 'must be a OneDrive URL' } };
  }
  if (!validateOneDriveId(value)) {
    return { invalidUrl: { reason: 'invalid OneDrive file ID format' } };
  }
  return null;
};
